import { get } from '@alltrails/shared/api';

export async function getNlSuggestions() {
  return get<any>(`/api/alltrails/explore/v1/query_suggestions`, { params: { limit: 6 } });
}
